import "./radioGroup.css"
import RadioGroup from "./RadioGroup"
import RadioGroupChoiceCard from "./RadioGroupChoiceCard"
import RadioGroupItem from "./RadioGroupItem"

export type { RadioGroupProps } from "./RadioGroup"
export type { RadioGroupChoiceCardProps } from "./RadioGroupChoiceCard"
export type { RadioGroupItemProps } from "./RadioGroupItem"
export default Object.assign(RadioGroup, {
  Item: RadioGroupItem,
  ChoiceCard: RadioGroupChoiceCard,
})
